import React, { Component } from "react";
import Masonry from 'react-masonry-css';
import Image from 'react-image-webp';
import $ from 'jquery';

import listaAmbientes from '../assets/js/data/ambientes.json';

class Ambientes extends Component {
  
    componentDidMount() {

        $('[data-fancybox="gallery"]').fancybox({
            afterLoad : function(instance, current) {
                var pixelRatio = window.devicePixelRatio || 1;
        
                if ( pixelRatio > 1.5 ) {
                    current.width  = current.width  / pixelRatio;
                    current.height = current.height / pixelRatio;
                }
            }
        });

    }

    render() {
        const ambientes = listaAmbientes.ambientes;
        const breakpointColumnsObj = {
            default: 4,
            1100: 3,
            700: 2,
            500: 1
        };
        return (
            <section id="ambientes" className="ambient-area pt-120">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <Masonry
                                breakpointCols={breakpointColumnsObj}
                                className="my-masonry-grid"
                                columnClassName="my-masonry-grid_column"
                            >
                                {Object.keys(ambientes).map((v, i) => 
                                    <a href={require('../assets/images/ambientes/'+ambientes[v].imagem)} data-fancybox="gallery" data-caption="Ambientes" key={ambientes[v].key}>
                                        <Image src={require('../assets/images/ambientes/'+ambientes[v].imagem)} webp={require('../assets/images/webp/'+ambientes[v].webp)} alt={ambientes[v].titulo} id={ambientes[v].key} className="basic__img--ambient" />
                                    </a>
                                )}
                            </Masonry>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Ambientes;